var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 3.00016C18.3327 2.0835 17.5827 1.3335 16.666 1.3335H3.33268C2.41602 1.3335 1.66602 2.0835 1.66602 3.00016M18.3327 3.00016V13.0002C18.3327 13.9168 17.5827 14.6668 16.666 14.6668H3.33268C2.41602 14.6668 1.66602 13.9168 1.66602 13.0002V3.00016M18.3327 3.00016L9.99935 8.8335L1.66602 3.00016",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlue);
export default __webpack_public_path__ + "static/media/email-blue.d2df9a3ac9d1c513a00145e6803fe774.svg";
export { ForwardRef as ReactComponent };